import { render, staticRenderFns } from "./SubFieldListInputContainer.vue?vue&type=template&id=145d9c9b&scoped=true&"
import script from "./SubFieldListInputContainer.vue?vue&type=script&lang=js&"
export * from "./SubFieldListInputContainer.vue?vue&type=script&lang=js&"
import style0 from "./SubFieldListInputContainer.vue?vue&type=style&index=0&id=145d9c9b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d9c9b",
  null
  
)

export default component.exports